export { default as formatNumber } from './numbers/format-number';
export { default as parseNumber } from './numbers/parse-number';


//////////////////
// WEBPACK FOOTER
// ./~/@telerik/kendo-intl/dist/es/numbers.js
// module id = 399
// module chunks = 93